export default {
  zh: {
    affiliate: '联盟推广',
    inviteFriends: '邀请好友',
    referrals: '位',
    friendsNumExplain: '目前为止，您已邀请的好友数量',
    totallyRewards: '奖励总金额',
    CNY: '￥',
    USD: '$',
    withdrawAmount: '可提现金额',
    withdrawDetails: '提现明细',
    withdrawNumExplain: '最低提现金额￥100',
    withdraw: '申请提现',
    commissionReward: '奖励现金',
    commissionExplain: '好友充值成功，您将获得佣金奖励。',
    rewardsRules: '奖励规则'
  },
  en: {
    affiliate: 'Affiliate',
    inviteFriends: 'Invite Friends',
    referrals: 'Friend | Friends',
    friendsNumExplain: 'The number of friends you have invited',
    totallyRewards: 'Totally Rewards',
    reward: 'Rewards',
    CNY: '￥',
    USD: '$',
    withdrawAmount: 'Withdrawal Amount',
    withdrawDetails: 'Withdraw Details',
    withdrawNumExplain: 'Min amount of cash withdrawal $50',
    withdraw: 'Withdraw',
    days: 'day | days',
    instructions: 'For every friend who successfully buys a subscription, we’ll reward you corresponding free service.',
    commissionReward: 'Rewards',
    commissionExplain: 'If your friend purchases successfully, you will get commission.',
    rewardsRules: 'Reward Rules'
  }
}



// WEBPACK FOOTER //
// ./src/views/commission/lang.js